function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".404_svg__st0{fill:none;stroke:#000;stroke-width:4}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "404_svg__Path",
  className: "404_svg__st0",
  d: "M80.2 5.5H115v112.2h21.5V147H115v37H78.2v-37H2v-26.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "404_svg__Path_2_",
  className: "404_svg__st0",
  d: "M274.2 94.8c0 31.2-5.1 54.2-15.3 69.2-10.2 15-25.9 22.5-47.2 22.5-20.6 0-36.1-7.7-46.6-23.2s-15.7-38.3-15.7-68.5c0-31.5 5.1-54.7 15.3-69.6s25.8-22.4 47-22.4c20.6 0 36.2 7.8 46.7 23.4s15.8 38.5 15.8 68.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "404_svg__Path_4_",
  className: "404_svg__st0",
  d: "M365.6 5.5h34.8v112.2h21.5V147h-21.5v37h-36.8v-37h-76.2v-26.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "404_svg__Path_1_",
  className: "404_svg__st0",
  d: "M78.2 117.7s1.3-67.4 1.6-69h-1c-3 6.7-43.6 69-43.6 69h43z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "404_svg__Path_3_",
  className: "404_svg__st0",
  d: "M186.9 94.8c0 21.9 1.9 37.6 5.7 47.1s10.2 14.2 19.1 14.2c8.8 0 15.1-4.8 19-14.4s5.9-25.2 5.9-46.9c0-21.9-2-37.6-5.9-47.2s-10.3-14.3-19-14.3c-8.9 0-15.2 4.8-19 14.3s-5.8 25.3-5.8 47.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "404_svg__Path_5_",
  className: "404_svg__st0",
  d: "M363.6 117.7s1.3-67.4 1.6-69h-1c-3 6.7-43.6 69-43.6 69h43z"
});

function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "404_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 424 189",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MjQgMTg5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MjQgMTg5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2Utd2lkdGg6NDt9Cjwvc3R5bGU+Cjx0aXRsZT40MDQ8L3RpdGxlPgo8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KPHBvbHlnb24gaWQ9IlBhdGgiIGNsYXNzPSJzdDAiIHBvaW50cz0iODAuMiw1LjUgMTE1LDUuNSAxMTUsMTE3LjcgMTM2LjUsMTE3LjcgMTM2LjUsMTQ3IDExNSwxNDcgMTE1LDE4NCA3OC4yLDE4NCA3OC4yLDE0NyAyLDE0NyAyLDEyMC44Ii8+CjxwYXRoIGlkPSJQYXRoXzJfIiBjbGFzcz0ic3QwIiBkPSJNMjc0LjIsOTQuOGMwLDMxLjItNS4xLDU0LjItMTUuMyw2OS4yYy0xMC4yLDE1LTI1LjksMjIuNS00Ny4yLDIyLjVjLTIwLjYsMC0zNi4xLTcuNy00Ni42LTIzLjIKCXMtMTUuNy0zOC4zLTE1LjctNjguNWMwLTMxLjUsNS4xLTU0LjcsMTUuMy02OS42czI1LjgtMjIuNCw0Ny0yMi40YzIwLjYsMCwzNi4yLDcuOCw0Ni43LDIzLjRTMjc0LjIsNjQuNywyNzQuMiw5NC44eiIvPgo8cG9seWdvbiBpZD0iUGF0aF80XyIgY2xhc3M9InN0MCIgcG9pbnRzPSIzNjUuNiw1LjUKCTQwMC40LDUuNSA0MDAuNCwxMTcuNyA0MjEuOSwxMTcuNyA0MjEuOSwxNDcgNDAwLjQsMTQ3IDQwMC40LDE4NCAzNjMuNiwxODQgMzYzLjYsMTQ3IDI4Ny40LDE0NyAyODcuNCwxMjAuOCAiLz4KPHBhdGggaWQ9IlBhdGhfMV8iIGNsYXNzPSJzdDAiIGQ9Ik03OC4yLDExNy43YzAsMCwxLjMtNjcuNCwxLjYtNjloLTFjLTMsNi43LTQzLjYsNjktNDMuNiw2OUg3OC4yeiIvPgo8cGF0aCBpZD0iUGF0aF8zXyIgY2xhc3M9InN0MCIgZD0iTTE4Ni45LDk0LjhjMCwyMS45LDEuOSwzNy42LDUuNyw0Ny4xczEwLjIsMTQuMiwxOS4xLDE0LjJjOC44LDAsMTUuMS00LjgsMTktMTQuNAoJczUuOS0yNS4yLDUuOS00Ni45YzAtMjEuOS0yLTM3LjYtNS45LTQ3LjJzLTEwLjMtMTQuMy0xOS0xNC4zYy04LjksMC0xNS4yLDQuOC0xOSwxNC4zUzE4Ni45LDcyLjksMTg2LjksOTQuOHoiLz4KPHBhdGggaWQ9IlBhdGhfNV8iIGNsYXNzPSJzdDAiIGQ9Ik0zNjMuNiwxMTcuN2MwLDAsMS4zLTY3LjQsMS42LTY5aC0xYy0zLDYuNy00My42LDY5LTQzLjYsNjlIMzYzLjZ6Ii8+Cjwvc3ZnPgo=";
export { Svg404 as ReactComponent };